// extracted by mini-css-extract-plugin
module.exports = {"educationDegree":"index-module_educationDegree_1zLI4"};